import fetchCreator from "../utils/fetchCreator";

const client = new fetchCreator();

export const fetchBusinesses = () =>
  client.get(`clouds/business`).then((data: any) => data.data);

export const fetchBusinessRequests = () =>
  client
    .get(`/clouds/business/applications/pending`)
    .then((data: any) => data.data);

const approveBusiness = (body: any) =>
  client
    .patch("clouds/business/applications", body)
    .then((response) => response);

export const acceptBusiness = (business_id: string) =>
  approveBusiness({ user_id: business_id, action: "accept" });

export const declineBusiness = (business_id: string) =>
  approveBusiness({ user_id: business_id, action: "decline" });

export const fetchBusinessPayments = () =>
  client
    .get(`/billing/business/account?augmented=true`)
    .then((data: any) => data.data);

export const updateBusiness = (business_profile: any) =>
  client
    .put("business/profile", business_profile)
    .then(console.log)
    .catch(console.error);
